import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import BookingPreview from './BookingPreview';

const { FiArrowUpRight, FiPlay, FiCalendar } = FiIcons;
const bookingUrl = 'https://optmise.com';

function Hero({ onNavigate }) {
  return (
    <section className="hero panel-section" id="home">
      <div className="hero-copy">
        <motion.div className="eyebrow" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <span><SafeIcon icon={FiCalendar} /></span>
          Scheduling, reimagined
        </motion.div>
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
          Your time deserves a <em>smarter</em> system.
        </motion.h1>
        <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
          A ready-to-use appointment platform that adapts to your brand, your workflow, and the people you serve.
        </motion.p>
        <motion.div className="hero-actions" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.2 }}>
          <button className="primary-button" type="button" onClick={() => { window.open(bookingUrl, '_blank', 'noopener,noreferrer'); }}>
            Build my booking flow
            <SafeIcon icon={FiArrowUpRight} />
          </button>
          <button className="text-button" type="button" onClick={() => onNavigate('services')}>
            <span><SafeIcon icon={FiPlay} /></span>
            See how it works
          </button>
        </motion.div>
        <div className="hero-proof">
          <div className="avatar-stack">
            {['photo-1494790108377-be9c29b29330', 'photo-1500648767791-00dcc994a43e', 'photo-1534528741775-53994a69daeb'].map((photo) => (
              <img key={photo} src={`https://images.unsplash.com/${photo}?auto=format&fit=crop&w=80&q=80`} alt="" />
            ))}
          </div>
          <p><strong>4.9/5</strong><span>Loved by growing businesses</span></p>
        </div>
      </div>
      <div className="hero-visual"><BookingPreview /></div>
    </section>
  );
}

export default Hero;